
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15 20.5V17.96C15 17.51 14.46 17.29 14.15 17.61L13.59 18.17L5.09999 9.68003C4.70999 9.29003 4.07999 9.29003 3.68999 9.68003C3.29999 10.07 3.29999 10.7 3.68999 11.09L12.18 19.58L11.62 20.14C11.3 20.46 11.52 21 11.96 21H14.5C14.78 21 15 20.77 15 20.5ZM11.25 8.48003L14.79 12.02L14.12 13.62C13.97 13.98 14.05 14.39 14.33 14.67C14.82 15.16 15.64 14.99 15.9 14.35L19.51 5.26003C19.68 4.84003 19.58 4.35003 19.26 4.03003C18.94 3.71003 18.46 3.61003 18.03 3.78003L8.92999 7.38003C8.28999 7.63003 8.11999 8.46003 8.60999 8.95003C8.87999 9.22003 9.28999 9.30003 9.64999 9.15003L11.25 8.48003ZM17.84 5.43003L15.61 10.3L12.97 7.66003L17.84 5.43003Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-text-rotation-angledown`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconTextRotationAngledown

    ```js
    <b-new-b-icon-text-rotation-angledown />
    ```
</docs>


